import { FuseNavigationItem } from "@fuse/components/navigation";

export const fullCompactNavigation: FuseNavigationItem[] = [
    {
        id      : 'examination',
        title   : 'Tests',
        tooltip : 'Tests',
        type    : 'basic',
        icon    : 'heroicons_outline:clipboard-document-list',
        link    : '/examination-list'
    },
    {
        id      : 'exercice',
        title   : 'Exercices',
        tooltip : 'Exercices',
        type    : 'basic',
        icon    : 'heroicons_outline:cash',
        link    : '/exercises-list'
    },
    {
        id      : 'slides',
        title   : 'Slide Texte',
        tooltip : 'Slide Texte',
        type    : 'basic',
        link    : '/slide-text-list'
    }  
];